import axios, { AxiosInstance, AxiosRequestConfig } from 'axios';

const UNAUTHORIZED = 401;

interface IProps {
  getAuthToken?: () => string;
  logout?: () => void;
  config?: AxiosRequestConfig;
}

export class HttpClient {
  private axiosClient: AxiosInstance;
  private getAuthToken?: () => string;
  private logout?: () => void;

  constructor(props: IProps) {
    this.axiosClient = axios.create(props.config);
    this.setupRequestInterceptor();
    this.setupResponseInterceptor();
    this.getAuthToken = props.getAuthToken;
    this.logout = props.logout;
  }

  public get(...args: Parameters<typeof axios.get>) {
    return this.axiosClient.get(...args);
  }

  public post(...args: Parameters<typeof axios.post>) {
    return this.axiosClient.post(...args);
  }

  public patch(...args: Parameters<typeof axios.patch>) {
    return this.axiosClient.patch(...args);
  }

  public delete(...args: Parameters<typeof axios.delete>) {
    return this.axiosClient.delete(...args);
  }

  public put(...args: Parameters<typeof axios.put>) {
    return this.axiosClient.put(...args);
  }

  private setupRequestInterceptor = () => {
    this.axiosClient.interceptors.request.use(
      (config) => {
        const authToken = true;

        if (!authToken) {
          throw new Error('You must provide an authorization token.');
        }

        config.headers.Authorization = `Bearer ${authToken}`;

        return config;
      },

      (error) => {
        return Promise.reject(error);
      },
    );
  };

  private setupResponseInterceptor = () => {
    this.axiosClient.interceptors.response.use(
      (response) => {
        return response;
      },
      (error) => {
        // if (error.status === UNAUTHORIZED) {
        //   return this.logout();
        // }
		
        return Promise.reject(error);
      },
    );
  };
}